
    export async function monaco_module() {
        return import(
            /* webpackChunkName: "monaco-exts" */
            /* webpackMode: "eager" */
            '../../../../dist/esm/monaco.js'
        ); 
    }
